// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"intakeForm_wrapper__3qDxh","leftSide":"intakeForm_leftSide__V9DB8","footer":"intakeForm_footer__2oHco"};